import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useNavigate } from "react-router-dom";

export default function BillingWarningModal() {
  const [open, setOpen] = useState(false);
const navigate = useNavigate();

  useEffect(() => {
    const isUnpaid = sessionStorage.getItem("BillingWarning");
    if (isUnpaid === "true") {
      setOpen(true);
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
  };



  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle className="d-flex align-items-center gap-2 text-warning">
        <WarningAmberIcon color="warning" />
        Payment Required
      </DialogTitle>
      <DialogContent>
      <p className="mb-0">
  Your laboratory subscription payment is currently pending. Please complete your payment under{" "}
  <strong
    style={{
      color: "#1976d2",
      cursor: "pointer",
      textDecoration: "underline",
    }}
    onClick={() => {
      handleClose();
      navigate("/Home/labs-Billing"); // Replace with your Billing route
    }}
  >
    Billing
  </strong>{" "}
  to continue using all system features without interruption.
</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="warning" variant="contained">
          I Understand
        </Button>
      </DialogActions>
    </Dialog>
  );
}